import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  ApiBuilder,
  AppConfigService,
  HttpHeadersPayload,
  HttpRequestMethods,
  ReplaceItem,
  handleError
} from '@com-delta-idp/mnx-utils';
import { Observable } from 'rxjs';
import { EndpointKey, IDP_APP, MFA_OAUTH_URL } from '../../../../constants';
import { OauthAEMConfig } from '../../../../models';
import {
  MethodSelectionPayload,
  SubmitFlyDeltaMethod
} from '../../../../models/multi-factor-authentication.interfaces';
import { UtilService } from '../../../util-service/util-service';

@Injectable({
  providedIn: 'root'
})
export class SubmitFlyDeltaMethodSelectionService {
  submitFlyDetlaMfaHeader: HttpHeadersPayload = {
    'Content-Type':
      'application/vnd.pingidentity.selectDevicePairingMethod+json',
    'X-XSRF-Header': 'PingFederate',
    rejectUnauthorized: 'false'
  };

  _errorHandler = handleError.bind(this);

  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private utils: UtilService
  ) {}

  submitFlyDeltaMethodSelection = (
    authConfig: OauthAEMConfig,
    flowIdValue: string,
    flyDeltaMethodSelection: MethodSelectionPayload
  ): Observable<SubmitFlyDeltaMethod> => {
    const flyDeltaMethodSelectionUrl = this.utils.getPingServiceUrl(
      authConfig,
      flowIdValue
    ).loginAuthWithCredentialsUrl;

    const submitFlyDeltaMethodMfaUrl: ReplaceItem[] = [
      {
        src: MFA_OAUTH_URL,
        target: flyDeltaMethodSelectionUrl
      }
    ];

    return new ApiBuilder<MethodSelectionPayload, SubmitFlyDeltaMethod>(
      this.http,
      this.appConfig
    )
      .app(IDP_APP.COMMON)
      .endpointKey(EndpointKey.MFA_OAUTH_URL)
      .overrideEndpoint(submitFlyDeltaMethodMfaUrl)
      .method(HttpRequestMethods['POST'])
      .timeOut(authConfig.MFA_TIMEOUT ?? 10000)
      .payload(flyDeltaMethodSelection)
      .httpHeaders(this.submitFlyDetlaMfaHeader)
      .errorHandler(this._errorHandler)
      .library('SUBMIT_FLY_DELTA_METHOD_SELECTION_SERVICE')
      .withCredentials(true)
      .create();
  };
}
